<template>
  <CactusAutocomplete
    :multiple="false"
    :api-service="userDetailsAPI"
    :load-immediate="true"
    label="Researcher"
    item-text="first_name"
    search-prop="first_name"
    v-bind="$attrs"
    v-model="selected">
  </CactusAutocomplete>
</template>

<script>
import CactusAutocomplete from '@/components/inputs/autocomplete--agnostic.vue'
import UserDetailsAPI from '@/api/userdetails.js'
import {mapState} from 'vuex'
export default {
  components: {
    CactusAutocomplete
  },
  props: {
    setDefaultAsUser: {
      type: Boolean,
      default: false
    },
    value: {
      required: true
    }
  },
  data () {
    return {
      selected: undefined
    }
  },
  computed: {
    ...mapState(['user'])
  },
  created () {
    this.selected = this.value
    this.userDetailsAPI = UserDetailsAPI
    this.setDefault()
  },
  methods: {
    setDefault () {
      if (this.setDefaultAsUser && this.user) {
        console.log('setting default')
        this.selected = this.user.userDetails
      }
    }
  },
  watch: {
    value (val) {
      this.selected = val
    },
    selected (val) {
      this.$emit('input', val)
    },
    user (val) {
      this.setDefault()
    }
  }
}
</script>

<style>

</style>
